import React, { useState } from 'react';
import ReportView from '../components/report/ReportView';

const ReportPage = () => {
  // Mocking report data based on ID
  const reportMock = {
    propertyAddress: '123 Main St, Cape Town',
    maskedName: 'J*** D***',
    rent: 15000,
    version: '1.0',
    generatedAt: new Date().toISOString(),
    validUntil: new Date(Date.now() + 30*86400000).toISOString(),
    identity: { method: 'Visual Review', result: 'Match', notes: 'Clear ID provided.', sourceDate: new Date().toISOString() },
    income: { declaredGross: 45000, verifiedGross: 45000, grossRatio: 33.3, netRatio: 45.0, calcDate: new Date().toISOString() },
    credit: { summary: 'Good standing', indicators: '0 defaults', provider: 'TransUnion SA' },
    exceptions: []
  };

  return (
    <div className="report-page" style={{ padding: '20px' }}>
      <ReportView report={reportMock} />
    </div>
  );
};
export default ReportPage;
